import configJson from '../config/config.json';
import { handleResponse } from './apiService';
import { CH_ACCOUNT } from '../constants/general';
import callTx from './txService';
import { HordTicketManagerContract } from './contractsRegistryService';

export const getChampionToken = () => window.localStorage.getItem(CH_ACCOUNT);

export const championSignUp = () => {
  const redirectUrl = `${window.location.origin}/verify`;

  window.location.href = `${configJson.apiPath}/oauth/twitter/authorize?redirect_url=${redirectUrl}`;
};

export const getChampionProfileData = (handle) =>
  fetch(`${configJson.apiPath}/champion?handle=${handle}`).then((res) => handleResponse(res, false));

// TODO: integrate backend
export const getChampionProfilePools = () => [];
export const getChampionPoolsTiles = () => {
  const config = {
    method: 'GET',
    headers: { Authorization: `Bearer ${getChampionToken()}` },
  };
  return fetch(`${configJson.apiPath}/hpool/list`, config)
    .then(handleResponse)
    .then(({ hpools }) => hpools);
};

export const getChampionOwnerData = (token) => {
  const config = {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  };

  return fetch(`${configJson.apiPath}/user/profile`, config).then((res) => handleResponse(res, true));
};

export const stakeToChampionNft = async (account, stakeAmount, nftId) => {
  const contract = await HordTicketManagerContract();
  return callTx(contract, 'stakeAndReserveNFTs', [nftId, stakeAmount], { from: account });
};

export const getHPoolList = () => {
  const config = {
    method: 'GET',
    headers: { Authorization: `Bearer ${getChampionToken()}` },
  };
  return fetch(`${configJson.apiPath}/hpool/list`, config).then(handleResponse);
};

window.getHPoolList = getHPoolList;

export const submitChampionOwnerSocialsForm = (data) => {
  const token = window.localStorage.getItem(CH_ACCOUNT);

  const { telegram, facebook, youtube, otherName, otherUrl } = data;

  const config = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      tg_handle: telegram,
      facebook_profile_url: facebook,
      youtube_channel_url: youtube,
      misc_social_link_url_1: otherUrl,
      misc_social_link_name_1: otherName,
    }),
  };

  return fetch(`${configJson.apiPath}/champion`, config).then((res) => handleResponse(res, true));
};
